<template>
    <div id="settings">
        <div class="row">
            <div class="col-xs-12" style="padding: 3px;">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <center>
                                <div class="col-xs-12"><h3>Настройки</h3></div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12" style="padding: 3px;">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col-xs-12">
                                <center>
                                    <router-link to="/first">
                                        <button class="btn btn-default btn-lg" style="width: 230px;">Выбор поставщика
                                        </button>
                                    </router-link>
                                </center>
                            </div>
                        </div>
<!--                        <div class="row" style="margin-top: 20px;">-->
<!--                            <div class="col-xs-12">-->
<!--                                <center>-->
<!--                                    <button class="btn btn-default btn-lg" style="width: 230px;">Дебиторка</button>-->
<!--                                </center>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="row" style="margin-top: 20px;">
                            <div class="col-xs-12">
                                <center>
                                    <router-link to="/obmen">
                                        <button class="btn btn-success btn-lg" style="width: 230px;">Обновить каталог
                                        </button>
                                    </router-link>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="menu"
             style="position: fixed;z-index: 9990;background: rgba(4,7,6,0.27);height: 60px;bottom:0px;width: 100%;">
            <div class="col-xs-12"
                 style=" padding-left: 4%; padding: 0px;border-top:1px ridge rgba(4,7,6,0.16);">
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/catalog">
                        <center>
                            <i class="ti-agenda" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Каталог</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/order">
                        <center>
                            <i class="ti-shopping-cart" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Заказ</span>
                        </center>
                    </router-link>
                </div>

                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/orderslist">
                        <center>
                            <i class="ti-timer" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">История</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: #ececec;padding: 10px;">
                    <router-link to="/settings">
                        <center>
                            <i class="ti-more-alt" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Ещё</span>
                        </center>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Settings'
  }
</script>

<style scoped>
    .row {
        margin: 0px;
    }

    a {
        color: #000000;
    }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/Settings.vue